import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ROUTE_SCROLL_CONTAINERS = ".atlas-main, .admin-main";

export function RouteScrollManager() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (!("scrollRestoration" in window.history)) return;
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => {
      window.history.scrollRestoration = previous;
    };
  }, []);

  useLayoutEffect(() => {
    if (hash) return;

    const root = document.documentElement;
    const previousBehavior = root.style.scrollBehavior;

    // The site normally uses smooth scrolling for in-page links. Temporarily
    // disable it here so a new route is at the top before the next frame paints.
    root.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    root.scrollTop = 0;
    document.body.scrollTop = 0;
    document
      .querySelectorAll<HTMLElement>(ROUTE_SCROLL_CONTAINERS)
      .forEach((container) => {
        container.scrollTop = 0;
        container.scrollLeft = 0;
      });
    root.style.scrollBehavior = previousBehavior;
  }, [pathname, hash]);

  return null;
}
